import React from 'react'
import { getToolUrl } from '@services/ToolMenuConfigService'
import { IOperationsTabConfig } from '../../types'
import PromotionsView, { PROMOTIONS_ASSET_ID, PROMOTIONS_DISPLAY_NAME } from './PromotionsView'

/**
 * The Promotions tab: the Promotions page embedded as the panel. No metric line yet.
 *
 * Shown only where the Promotions tool resolves to a URL for this domain and platform (registered
 * for beta and gamma), so users elsewhere never see a tab that opens a blank panel.
 */
export const promotionsTab: IOperationsTabConfig = {
    id: 'promotions',
    labelStringId: 'jsma-web-operations-promotionsTabLabel',
    renderContent: () => <PromotionsView />,
    // Keep the iframe mounted across tab switches so it is not reloaded.
    keepMounted: true,
    isAvailable: () => !!getToolUrl(PROMOTIONS_DISPLAY_NAME, PROMOTIONS_ASSET_ID),
}
